import { module } from 'angular';
import { ngModule as foundationPricingModule } from 'cg-foundation-pricing';
import { DrButtonComponent } from './components/dr-button';
import { SolutionSummaryBoxComponent } from './components/solution-summary-box';
import { StickyDirective } from './directives/sticky';
import { CartChannelService } from './services/cart-channel';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.summarybox', [foundationPricingModule.name])
    .service('cartChannel', CartChannelService)
    .directive('sticky', StickyDirective)
    .component('drButton', DrButtonComponent)
    .component('solutionSummaryBox', SolutionSummaryBoxComponent);
